module.exports = __webpack_public_path__ + "img/ch-infant-youth.ca93c249.jpg";